/**
 * author Jia ZhiBo
 */

/**
 * 目前支持_json串字段
 * id------------------------------(必填)
 * name----------------------------(必填)
 * hidden--------------------------(选填，默认为显示) true/false
 * batch_hidden--------------------(选填) 批量添加是否显示
 * couldMod------------------------(选填) 是否允许修改
 * couldBatchMod-------------------(选填) 是否支持批量修改)不支持则隐藏该字段
 * type----------------------------(hidden为true时可不填)页面显示类型
 *    text, select, password, checkbox, checkArray, text[]
 * showName------------------------(必填)界面展示名称
 * placeholder---------------------(选填)提示信息
 * modifyShow----------------------(选填)修改是否显示, 默认为显示 true/false
 * value---------------------------(选填)默认值
 * readonly------------------------(选填)是否只读) true/false
 * uiIndex-------------------------(选填)UI呈现位置,不填则隐藏
 * groupBy-------------------------(选填)业务分组,不填默认noGroup组
 * attrList------------------------(特殊)type为text[]时必填此项, 包含count,list两个字段
 * validate------------------------(选填)验证规则 详情参照 https://ej2.syncfusion.com/vue/documentation/form-validator/validation-rules/?no-cache=1
 *   { :例
 *   maxLength:1,
 *   required:true
 *   }
 * options-------------------------(type为select和checkbox时必填)下拉框/多选框属性 Notice:下拉框建议增加默认值; type为checkArray时, value必须连续
 *   { :例
 *     showName:'API',
 *     value:0
 *   }
 */

/**
 * Methods
 * constructor 构造器 {
 *   _json: 需要适配的资源
 *   _mapCap: 单行显示列数
 *   _checkBoxSize: 多选框单行显示列数
 *   paramsData: mml请求后回显在页面上的数据(修改时用)
 * }
 */
class SubscriberArr {
  constructor(_json = [], _maxCap = 2, _checkBoxSize = 3) {
    this._json = _json;
    this._maxCap = _maxCap;
    this._checkBoxSize = _checkBoxSize;
    this._group = this.$getGroup(_json);
    this._getFlag = 0; // 获取数组方式 0:调用的为getTemplet方法 1:调用的为getTempletByGroup方法
    this._addFlag = 0;
  }

  /**
   * 数据组合方法(修改,回显)
   * 入参 Map or Array
   * @param _paramsData
   */
  setDatas(_paramsData) {
    this._json = this.$initSelectParams(this._json);
    if (_paramsData instanceof Map) {
      this._json.forEach((_item) => {
        if (_paramsData.get(_item.name) !== undefined) {
          _item.value = _paramsData.get(_item.name);
        }
        // type为text[] 类型时的额外判断, 将list返回值以数组的形式赋给某一模板字段, 待运用ParseList时, 再生成多组数据。
        if (_item.attrList !== undefined && _item.attrList[0].name === 'count' && _item.attrList[1].name === 'list' && _item.attrList[1].attrList !== undefined) {
          if (_paramsData.get(_item.name) === undefined) return true;
          const _listLength = _paramsData.get(_item.name).count;
          _item.attrList[1].attrList.forEach((_attrTemp) => {
            const _attrTempComb = [];
            let _index = 0;
            const _itemList = _paramsData.get(_item.name).list;
            while (_index < _listLength) {
              _attrTempComb.push(_itemList[_index][_attrTemp.name])
              _index++;
            }
            _attrTemp.valueList = _attrTempComb;
          });
        }
        return true;
      });
    } else {
      this._json.forEach((_item) => {
        if (_paramsData[_item.name] !== undefined) {
          _item.value = _paramsData[_item.name];
        }
        // type为text[] 类型时的额外判断, 将list返回值以数组的形式赋给某一模板字段, 待运用ParseList时, 再生成多组数据。
        if (_item.attrList !== undefined && _item.attrList[0].name === 'count' && _item.attrList[1].name === 'list' && _item.attrList[1].attrList !== undefined) {
          if (_paramsData[_item.name] === undefined) return true;
          const _listLength = _paramsData[_item.name].count;
          _item.attrList[1].attrList.forEach((_attrTemp) => {
            const _attrTempComb = [];
            let _index = 0;
            const _itemList = _paramsData[_item.name].list;
            while (_index < _listLength) {
              _attrTempComb.push(_itemList[_index][_attrTemp.name])
              _index++;
            }
            _attrTemp.valueList = _attrTempComb;
          });
        }
        return true;
      });
    }
  }

  /**
   * 获取模板数组
   * @param _addFlag
   * @returns {{_jsonShow: Array, _jsonHide: Array, _lineSize: number, _checkSize: number}}
   */
  getTemplet(_addFlag = 0) {
    this._getFlag = 0;
    this._addFlag = _addFlag;
    let _tempJson = this._json;
    if (_addFlag === 0 || _addFlag === -1) {
      _tempJson = this.$initSelectParams(this._json);
    }
    _tempJson = this.$devideByUiIndex(_tempJson);
    return this.$devideArrToShowAndHide(_tempJson, _addFlag);
  }

  /**
   * 获取分组后的模板数组
   * @param _addFlag
   * @returns {Map<any, any>}
   */
  getTempletByGroup(_addFlag = 0) {
    this._getFlag = 1;
    this._addFlag = _addFlag;
    let _tempJson = this._json;
    if (_addFlag === 0 || _addFlag === -1) {
      _tempJson = this.$initSelectParams(this._json);
    }
    return this.$devideByGroupBy(_tempJson, _addFlag);
  }

  /**
   * 重加载方法
   * @returns {*}
   */
  reLoad() {
    if (this._getFlag === 0) {
      return this.getTemplet(this._addFlag);
    } else if (this._getFlag === 1) {
      return this.getTempletByGroup(this._addFlag);
    } else {
      return null;
    }
  }

  /**
   * 深复制type类型为text[]数据
   * @param obj
   * @returns {Array}
   */
  deepCloneTextArray(obj) {
    if (obj.length === 0) return [];
    const _arrayTextArray = [];
    obj.forEach((_array) => {
      if (_array.type === 'text[]') {
        const _data = {
          _name: _array.name,
          _modelName: _array.groupBy,
          _template: []
        };
        if (_array.attrList === undefined || _array.attrList[1] === undefined) {
          console.log('attrList为undefined！');
          return false;
        }
        const _arr = JSON.parse(JSON.stringify(_array.attrList[1].attrList));
        _data._template = _arr;
        _arrayTextArray.push(_data);
      }
      return true;
    });
    return _arrayTextArray;
  }

  /**
   * 下拉框改变控制的模板覆盖方法
   * @param _coverParams
   */
  $templetCover(_coverParams) {
    for (let i = 0; i < this._json.length; i++) {
      _coverParams.forEach((_cParams) => {
        if (this._json[i].name === _cParams.name) {
          this._json[i] = _cParams;
          if (_cParams.type !== 'checkBox' && _cParams.type !== 'checkArray') {
            const _oldOptions = this._json[i].options;
            if (_oldOptions !== undefined) this._json[i].options = _oldOptions;
          }
        }
      });
    }
  }

  /**
   * tr/td分组方法
   * @param _json
   * @param _addFlag -1:批量添加 0:添加 1:修改 2:批量修改
   * @returns {{_jsonShow: Array, _jsonHide: Array, _lineSize: number, _checkSize: number}}
   */
  $devideArrToShowAndHide(_json, _addFlag) {
    const _data = {
      _jsonShow: [], // 显示属性数组,按照_maxCap分组
      _jsonHide: [], // 隐藏属性数组
      _lineSize: this._maxCap, // 单行容量,
      _checkSize: this._checkBoxSize
    };
    let _tempShow = []; // 缓存数组,最大容量_maxCap
    _json.forEach((_item) => {
      if (_item.type === 'textArray') return true;
      if (_addFlag !== 0) { // 修改&批量添加
        // 修改可呈现字段
        if (_addFlag !== -1) { // 修改
          if (_item.modifyShow === false) {
            _item.hidden = true;
          } else if (_item.modifyShow === true) {
            _item.hidden = false;
          }
          // 可修改字段
          if (_item.couldMod === false) {
            _item.readonly = true;
          }
          if (_addFlag === 2) { // 批量修改
            // 可批量修改字段
            if (_item.couldBatchMod === false) {
              _item.hidden = true;
            }
          }
        } else if (_addFlag === -1) { // 批量添加
          if (_item.batch_hidden === true) {
            _item.hidden = true;
          } else if (_item.batch_hidden === false) {
            _item.hidden = false;
          }
        }
      }
      if (_item.uiIndex === undefined) _item.hidden = true;
      switch (_item.hidden) {
        case true:
          _data._jsonHide.push(_item);
          break;
        case false:
          if (_item.type === 'checkbox' || _item.type === 'checkArray') {
            if (_tempShow.length !== 0) {
              if (_tempShow.length === 1) {
                _tempShow.push([]);
              }
              _data._jsonShow.push(_tempShow);
              _tempShow = [];
            }
            if (_item.value !== undefined && _item.type === 'checkbox') {
              _item.value = parseInt(_item.value);
            }
            if (_item.options[0] !== undefined && _item.options[0].value === 0) { _item.options[0].value = '0'; } // 解决checkbox不能赋值为 0 只能赋值为 ‘0’ 的问题, 该判断仅适配数组第0位为0的情况。
            _tempShow.push(_item);
            _data._jsonShow.push(_tempShow);
            _tempShow = [];
          } else {
            _tempShow.push(_item);
          }
          break;
        default:
      }
      if (_tempShow.length === _data._lineSize) { // 如果当前已达到分组最大容量,则放入数组,并清空分组缓存
        _data._jsonShow.push(_tempShow);
        _tempShow = [];
      }
      return true;
    });
    if (_tempShow.length !== 0) { // 如果当前已经循环结束,但当前分组缓存还未达到最大容量,依然推入数组
      if (_tempShow.length === 1) {
        _tempShow.push([]);
      }
      _data._jsonShow.push(_tempShow);
    }
    return _data;
  }

  /**
   * 根据UIINDEX排序数组
   * @param _json
   * @returns {*}
   */
  $devideByUiIndex(_json) {
    for (let i = 0; i < _json.length; i++) { // 冒泡
      for (let j = i + 1; j < _json.length; j++) {
        if (_json[i].uiIndex !== undefined && _json[j].uiIndex !== undefined && _json[i].uiIndex > _json[j].uiIndex) {
          const _tempItem = _json[i];
          _json[i] = _json[j];
          _json[j] = _tempItem;
        }
      }
    }
    return _json;
  }

  /**
   * 获取groupBy分组Set
   * @param _json
   * @returns {any[]}
   */
  $getGroup(_json) {
    const _groupSet = new Set();
    _json.forEach((_item) => {
      if (_item.groupBy === undefined) {
        _groupSet.add('noGroup');
      } else {
        _groupSet.add(_item.groupBy);
      }
    });
    return Array.from(_groupSet);
  }

  /**
   * 根据groupBy分组
   * @param _json
   * @param _addFlag
   * @returns {Map<any, any>}
   */
  $devideByGroupBy(_json, _addFlag) {
    const _groupTemp = this._group;
    const _mapByGroup = new Map();
    _groupTemp.forEach((_groupItem) => {
      let _arr = [];
      _json.forEach((_item) => {
        if (_item.groupBy === undefined && _groupItem === 'noGroup' && _item.type !== 'text[]') {
          _arr.push(_item);
        } else if (_item.groupBy === _groupItem && _item.type !== 'text[]') {
          _arr.push(_item);
        } else if (_item.groupBy === _groupItem && _item.type === 'text[]') {
          _arr = _item.attrList[1].attrList;
          return false; // textArray不支持多个字段所属一个groupBy, 如出现, 只识别第一个
        }
        return true;
      });
      if (_arr.length > 0) {
        _arr = this.$devideByUiIndex(_arr);
        _arr = this.$devideArrToShowAndHide(_arr, _addFlag);
        _mapByGroup.set(_groupItem, _arr);
      }
    });
    return _mapByGroup;
  }

  /**
   * 初始化加载默认屏蔽字段
   * @param _json
   * @returns {*}
   */
  $initSelectParams(_json) {
    for (let i = 0; i < _json.length; i++) {
      if (_json[i].changeClick === true && _json[i].options !== undefined) {
        const _options = _json[i].options;
        let _attr = null;
        for (let x = 0; x < _options.length; x++) {
          if (_json[i].value === undefined && _options[x].value !== undefined) { // 如果不存在默认值则设置 第一个options为默认值
            _json[i].value = _options[x].value;
          }
          if (_json[i].value === _options[x].value) { // 寻找默认值对应attr
            _attr = _options[x].attr === undefined ? null : _options[x].attr;
            break;
          }
        }
        if (_attr !== null) { // 不存在attr属性则返回
          for (let m = 0; m < _attr.length; m++) {
            for (let n = 0; n < _json.length; n++) {
              if (_attr[m].name === _json[n].name) {
                const oldOptions = _json[n].options;
                _json[n] = _attr[m];
                if (_attr[m].type !== 'checkbox' && _attr[m].type !== 'checkArray') {
                  if (oldOptions !== undefined) _json[n].options = oldOptions;
                  break;
                }
              }
            }
          }
        }
      }
    }
    return _json;
  }

  /**
   * 为type为text[]类型设计的独有处理多组数据方法
   * @param _formParams
   * @returns {Array}
   */
  $typeTextToArray(_formParams) {
    const resultArr = [];
    const _listLength = _formParams.json._jsonShow.length > 0
      ? _formParams.json._jsonShow[0][0].valueList.length : (_formParams.json._jsonHide.length > 0 ? _formParams.json._jsonHide[0].valueList.length : 0);
    for (let i = 0; i < _listLength; i++) {
      const _tempJsonHide = [];
      const _tempJsonShow = [];
      // JsonHide 赋值逻辑
      _formParams.json._jsonHide.forEach((_item) => {
        const _itemClone = JSON.parse(JSON.stringify(_item));
        const _itemValue = _itemClone.valueList;
        _itemClone.value = _itemValue[i];
        _tempJsonHide.push(_itemClone);
      });
      // JsonShow 赋值逻辑
      _formParams.json._jsonShow.forEach((_itemArray) => {
        const _tempArray = [];
        try {
          _itemArray.forEach((_itemBitArray) => {
            const _itemClone = JSON.parse(JSON.stringify(_itemBitArray));
            const _itemCloneValueArr = _itemClone.valueList;
            _itemClone.value = _itemCloneValueArr === undefined ? null : _itemCloneValueArr[i];
            _tempArray.push(_itemClone);
          });
          _tempJsonShow.push(_tempArray);
        } catch (e) {
          console.log('$typeTextToArray method error.');
        }
      });
      const _tempJson = {
        _checkSize: _formParams.json._checkSize,
        _lineSize: _formParams.json._lineSize,
        _jsonHide: _tempJsonHide,
        _jsonShow: _tempJsonShow
      };
      const _listItem = {
        json: _tempJson,
        formId: _formParams.formId + i,
        subObject: '',
        modelName: _formParams.modelName,
      };
      resultArr.push(_listItem);
    }
    return resultArr;
  }
}
export default SubscriberArr;
